import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import en from '../../utils/i18n/countryList/en.json'
import fr from '../../utils/i18n/countryList/fr.json'
import nl from '../../utils/i18n/countryList/nl.json'
import { useContext } from 'react'
import { LanguageContext } from '../../context'

const PhoneCustomInput = ({ value, onChange, inputProps }) => {

  const localizations = {
    fr: fr,
    en: en,
    nl: nl
  }

  const { t, currentLanguage } = useContext(LanguageContext)

  return (
    <>
      <PhoneInput
        country={'be'}
        value={value}
        onChange={onChange}
        enableSearch={true}
        inputProps={inputProps}
        searchPlaceholder={t('phone_input.search')}
        localization={localizations[currentLanguage] || localizations.en}
      />
    </>
  )
}

export default PhoneCustomInput
